import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MetaTags from '../components/common/MetaTags';
import './ThankYouPage.css';

const ThankYouPage = () => {
  const location = useLocation();
  const nomeCompleto = location.state?.nome || '';
  const primeiroNome = nomeCompleto.split(' ')[0]; // Extract first name
  const [progress, setProgress] = useState(0);
  const [countdown, setCountdown] = useState(15);

  const whatsappLink = 'https://chat.whatsapp.com/CTznMyvGPXh3eeITdEI9JT';

  useEffect(() => {
    // Animate progress bar to 90%
    const progressTimer = setTimeout(() => {
      setProgress(90);
    }, 2000);

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          // Redirect to WhatsApp
          window.location.href = whatsappLink;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearTimeout(progressTimer);
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <div className="thank-you-page">
      <MetaTags
        title="Inscrição Confirmada! - SBX Trade"
        description="Sua inscrição foi confirmada! Agora falta apenas um passo para garantir sua participação no grupo exclusivo."
        keywords="inscrição confirmada, SBX Trade, grupo WhatsApp, trade, trading"
        image="https://sbxtreinamentos.com.br/webinario/images/thank-you-og-image.jpg"
        url="https://sbxtreinamentos.com.br/webinario/obrigado"
        type="website"
        author="SBX Trade"
        siteName="SBX Trade"
      />
      <div className="thank-you-container">
        <div className="thank-you-content glass-card">
          {/* Loading Bar */}
          <div className="loading-bar-container">
            <div className="loading-bar-background">
              <div
                className="loading-bar-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="loading-text">
              Processando sua inscrição... {progress}% concluído
            </div>
          </div>
          <div className="thank-you-header">
            <h1 className="thank-you-title">
              Obrigado{primeiroNome ? `, ${primeiroNome}` : ''}, agora falta apenas <span className="highlight-text">um passo</span> para confirmar sua participação...
            </h1>

            <div className="countdown-display">
              <p>Redirecionamento automático em <span className="countdown-number">{countdown}</span> segundos...</p>
            </div>

          </div>
          <div className="thank-you-actions">
            <button
              className="cta-button"
              onClick={() => window.location.href = whatsappLink}
            >
              Entrar no grupo agora! ({countdown}s)
            </button>
          </div>


        </div>

        {/* Efeito de blur decorativo */}
        <div className="blur-effect blur-top"></div>
        <div className="blur-effect blur-bottom"></div>
      </div>
    </div>
  );
};

export default ThankYouPage;